import { useCallback, useState, useEffect, useRef } from 'react';
import { DatePicker } from 'antd';
import http from '../Http';
import utils from "../utils";
import { Button } from "@material-ui/core";
import ReactECharts from 'echarts-for-react';
import 'react-month-picker/css/month-picker.css';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import * as XLSX from 'xlsx';


function Discharge(props) {
    const { t } = useTranslation();
    const { setTip, deviceInfo, date, setDate } = props;

    //const [isCalendarOpen, setIsCalendarOpen] = useState(false);
    //const [date, setDate] = useState(new Date());
    const [dateScale, setDateScale] = useState(0); // 0 daily, 1 monthly, 2 yearly

    const chartEl = useRef(null);
    const chart = useRef(null);
    const refMonthPicker = useRef(null);
    const data = useRef(null);
    const deviceInfoRef = useRef(null);

    useEffect(() => {
        deviceInfoRef.current = deviceInfo;
    }, [deviceInfo]);

    const exportToExcel =  useCallback(() => {
        if (data.current == null || deviceInfoRef.current == null) {
            return;
        }

        let rs = 
        data.current.map((v) => {
            let r = {};
            if (v['YMDH']) {
                r[t("DataTime")] = v['YMDH'];
            } else if (v['YMD']) {
                r[t("DataTime")] = v['YMD'];
            } else if (v['YM']) {
                r[t("DataTime")] = v['YM'];
            }
            r[t("Cumulative Discharge")] = v['V']/10;
            return r;
        })

        const ws = XLSX.utils.json_to_sheet(rs);
        ws["!cols"] = [{wch: 21},{wch: 21}];
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        XLSX.writeFile(wb, deviceInfoRef.current.SN + '_Discharging.xlsx');
    }, [data, t]);

    
const option = {
    darkMode: true,
    tooltip: {
        trigger: 'axis',
        axisPointer: {
            type: 'shadow',
        },
    },
    toolbox: {
        right: 40,
        feature: {
            myDownloadXls: {
                show: true,
                title: t("Download"),
                icon: "path://M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7c3.2 4.1 9.4 4.1 12.6 0l112-141.7c4.1-5.2 0.4-12.9-6.3-12.9z M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6 0.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4 14.9-19.2 32.6-35.9 52.4-49.9 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7-23.4 23.4-54.5 36.3-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z",
                onclick: exportToExcel
            }
        }
    },
    grid: {
        left: 40,
        right: '4%',
        bottom: 40,
        containLabel: true
    },
    xAxis: [{
        type: 'category',
        boundaryGap: false,
        data: [],
        name: t('curve_axis.hour'),
        nameLocation: "center",
        nameGap: 25,
    }],
    yAxis: [
        {
            type: 'value',
            name: t('curve_axis.kwh'),
            nameLocation: "middle",
            nameRotate: 90,
            nameGap: 40,
        }
    ],
    series: [{
        name: t('discharge'),
        type: 'bar',
        smooth: true,
        itemStyle: {
            opacity: 0.8,
            color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                    offset: 0, color: '#2e7d32' // 起始颜色
                }, {
                    offset: 1, color: '#a5d6a7' // 结束颜色
                }],
                global: false
            }
        },
        emphasis: {
            focus: 'none'
        },
        data: []
    }]
};

const months = [
    t('months.january'), 
    t('months.february'), 
    t('months.march'),
    t('months.april'), 
    t('months.may'), 
    t('months.june'), 
    t('months.july'), 
    t('months.august'), 
    t('months.september'), 
    t('months.october'), 
    t('months.november'), 
    t('months.december')
];


    useEffect(() => {
        if (deviceInfoRef.current == null) {
            return;
        }

        let active = true;
        const ymd = utils.dateFormat("YYYY-mm-dd", date);

        if (dateScale == 0) {
            option.xAxis[0].data = ['1', '2', '3', '4', '5', '6', '7', '8', '9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24'];
            option.xAxis[0].name = t('curve_axis.hour');
        } else if (dateScale == 1) {
            const y = date.getFullYear();
            const m = date.getMonth();
            let days = Array(((new Date(y, m+1)).getTime() - (new Date(y, m)).getTime()) / 3600/1000/24);
            days.fill(0).forEach((v, i) => {
                days[i] = i+1;
            });
            option.xAxis[0].data = days;
            option.xAxis[0].name = t('curve_axis.day');
        } else {
            const ms = Array(12).fill(0)
            ms.forEach((v, i) => {
                ms[i] = i+1;
            })
            option.xAxis[0].data = ms;
            option.xAxis[0].name = t('curve_axis.month');
        }
        

        (async () => {
            let resp = await http.post("report/device/discharging/"+(dateScale==0?"daily":dateScale==1?"monthly":"yearly")+"/report", {
                "DeviceID": deviceInfoRef.current.ID,
                "DateTime": ymd,
            }).then(async (r)=>{
                return await r.json();
            }).catch((e)=>{
                console.log("Report Discharge", e);
                return null;
            });

            if (! active) {
                return;
            }
            
            if (resp == null || resp.code != 200) {
                setTip({
                    open: true, 
                    severity: "error", 
                    msg: (resp && resp.msg) ? resp.msg : t('load_data_error')
                });
                
                option.series[0].data = [];
            } else {
                let ds = {};
                let vs = [];

                const tag = dateScale == 0
                    ? "YMDH"
                    : dateScale == 1
                        ? "YMD"
                        : "YM";
                resp.data.forEach((v) => {
                    ds[v[tag]] = v;
                });
                for (let i=0; i<option.xAxis[0].data.length; i++) {
                    const dt = new Date(date.getFullYear(), 
                        (dateScale==2 ? i : date.getMonth()), 
                        (dateScale==2 ? 1 : dateScale==1 ? i : date.getDate()), 
                        (dateScale==0 ? i : 0)
                    );
                    const str = utils.dateFormat((dateScale==0 ? "YYYY-mm-dd HH:MM:SS": "YYYY-mm-dd"), dt);
                    if (ds[str]) {
                        vs.push(((ds[str]["V"])/10).toFixed(1));
                    } else {
                        vs.push(0);
                        //vs.push((Math.random()*100).toFixed(1));
                    }
                }
                option.series[0].data = vs;
            }

            //
            const instance = chart.current.getEchartsInstance();
            if (instance) {
                instance.setOption(option);
            }

            data.current = resp.data;
        })();

        return () => {
            active = false;
        };
    }, [deviceInfo, date, dateScale]);

    const handleShowPicker = () => {
        refMonthPicker.current.show();
    }
    const handleGoPreDate = () => {
        if (dateScale == 0) {
            setDate(new Date(date.setDate(date.getDate()-1)));
        } else if (dateScale == 1) {
            setDate(new Date(date.getFullYear(), date.getMonth()-1));
        } else {
            if (date.getFullYear() <= 2018) {
                setTip({
                    open: true, 
                    severity: "info", 
                    msg: t('date_exceeded')
                });
            }
            setDate(new Date(date.getFullYear()-1, 1));
        }
    }

    const handleGoNextDate = () => {
        const f = dateScale==0 ? "YYYY-mm-dd" : dateScale==1 ? "YYYY-mm" : "YYYY";
        if (utils.dateFormat(f, date).substr() >= utils.dateFormat(f, new Date())) {
            setTip({
                open: true, 
                severity: "info", 
                msg: t('date_exceeded')
            });
            return;
        }

        if (dateScale == 0) {
            setDate(new Date(date.setDate(date.getDate()+1)));
        } else if (dateScale == 1) {
            setDate(new Date(date.getFullYear(), date.getMonth()+1));
        } else {
            setDate(new Date(date.getFullYear()+1, 1));
        }
    }

    return (
        <div style={{
            flex: "1 1 auto",
            display: "flex",
            flexDirection: "column",
            alignItems: "stretch",
            backgroundColor: "white",
            overflow: 'auto',
            borderRadius: 10,
        }}>
            <div style={{
                flex: '0 0 auto',
                display: 'flex',
                flexDirection: 'row',
                backgroundColor: '#ccc',
            }}>
                <Button 
                    onClick={()=>{
                        if (dateScale == 0) {
                            return;
                        }

                        setDateScale(0);
                    }}
                    variant="contained"
                    style={{
                        borderRadius: 0,
                        color: dateScale==0 ? "white" : "black",
                        backgroundColor: dateScale==0 ? "#919292" : "#ccc",
                        flex: '1 1 auto'
                    }}
                >{t('Daily')}</Button>
                <Button
                    onClick={()=>{
                        if (dateScale == 1) {
                            return;
                        }

                        setDateScale(1);
                    }}
                    variant="contained"
                    style={{
                        color: dateScale==1 ? "white" : "black",
                        backgroundColor: dateScale==1 ? "#919292" : "#ccc",
                        flex: '1 1 auto'
                    }}
                >{t('Monthly')}</Button>
                <Button
                    onClick={()=>{
                        if (dateScale == 2) {
                            return;
                        }

                        setDateScale(2);
                    }}
                    variant="contained"
                    style={{
                        color: dateScale==2 ? "white" : "black",
                        backgroundColor: dateScale==2 ? "#919292" : "#ccc",
                        flex: '1 1 auto'
                    }}
                >{t('Yearly')}</Button>
            </div>
            {/* <div style={{
                flex: '0 0 60px',
                display: "flex",
            }}>
                <IconButton onClick={handleGoPreDate}>
                    <NavigateBeforeIcon style={{ fontSize: 30, color: "white", }} />
                </IconButton>
                <div style={{
                    flex: '1 0 auto',
                    display: "flex",
                    justifyContent: 'center',
                    alignItems: "center",
                    color: "white",
                    fontSize: 20
                }}>
                    {dateScale==0 ? (<DatePicker 
                        className={classes.calender}
                        disableClock={true}
                        value={new Date(date.getTime())}
                        format="yyyy-MM-dd"
                        maxDate={new Date()}
                        isCalendarOpen={isCalendarOpen}
                        locale="en"
                        onChange={(v) => {
                            setDate(v);
                        }}
                        onCalendarClose={() => {
                            setIsCalendarOpen(false);
                        }}
                    />) : dateScale==1 ? (<MonthPicker 
                        ref={refMonthPicker}
                        lang={months}
                        value={{year: 2021, month: 8}}
                        onChange={(y, m) => {
                            setDate(new Date(y, m-1));
                        }}
                    >
                        <div onClick={handleShowPicker} style={{border: "1px solid white",paddingLeft: 3,paddingRight: 3, cursor: "pointer"}}>{utils.dateFormat("YYYY-mm", date)}</div>
                    </MonthPicker>) : (
                        <FormControl className={classes.formControl}>
                            <NativeSelect
                                className={classes.selectYear}
                                style={{
                                    color: "white",
                                    fontSize: 20
                                }}
                                value={date.getFullYear()}
                                onChange={(e) => {
                                    setDate(new Date(e.target.value));
                                }}
                                name="year"
                            >
                                {Array((new Date()).getFullYear() - 2017).fill(0).map((v, idx) =>{
                                    return <option key={idx} value={2018+idx} style={{color: "black"}}>{2018+idx}</option>
                                })}
                            </NativeSelect>
                        </FormControl>
                    )}
                </div>
                <IconButton onClick={handleGoNextDate}>
                    <NavigateNextIcon style={{ fontSize: 30, color: "white", }} />
                </IconButton>
            </div> */}
            <div style={{
                flex: '1 0 20px',
                display: "flex",
                justifyContent: 'center',
                alignItems: "flex-end",
                color: "white",
                fontSize: 20,
            }}>
                <DatePicker
                    picker={dateScale==0 ? 'date' : dateScale==1 ? 'month' : 'year'}
                    locale="en"
                    onChange={(v) => {
                        setDate(v.toDate());
                    }}
                    //defaultValue={moment()}
                    value={moment(date)}
                    style={{borderRadius: '20px'}}
                />
            </div>
            <div style={{
                flex: "1 1 auto",
                display: "flex",
                flexDirection: "column",
                alignItems: 'stretch',
                overflow: "auto",
                padding: 5,
                backgroundColor: "white",
            }}>
                <div style={{
                    flex: "1, 1 auto",
                    minWidth: 400,
                }} ref={chartEl}>
                    <ReactECharts ref={chart} option={option} style={{ height: 400 }} />
                </div>
            </div>
        </div>
    )
}

export default Discharge;